import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { APP_CONFIG, AppConfig } from '../../../app-config.token';


let BASE_URL = '';

@Injectable({
  providedIn: 'root'
})
export class OutOfOfficeService {

  constructor(
    private http: HttpClient,
    @Inject(APP_CONFIG) private config: AppConfig
  ) {
    BASE_URL = config.masterApiURL;
   }

  public static apiCallsInProgress = 0;
  public static invalidDataCount = 0;
  private pendingApiCalls: any[] = [];
  invalidDataSections: any[] = [];

  private allCallsCompleted = new BehaviorSubject<boolean>(false);


  allCallsCompleted$ = this.allCallsCompleted.asObservable();


  setInvalidData(invalid: boolean, source: string) {
    if(invalid) {
      const uniqueData = Array.from(new Set(this.invalidDataSections));
    !uniqueData.includes(source) && uniqueData.push(source);

      this.invalidDataSections = uniqueData;
      OutOfOfficeService.invalidDataCount = this.invalidDataSections.length;
      console.log("this.invalidDataSections =============", this.invalidDataSections)
    } else {
      OutOfOfficeService.invalidDataCount--;

      const i = this.invalidDataSections.findIndex((p: string)=> p == source);
      i > -1 && this.invalidDataSections.splice(i, 1);
      OutOfOfficeService.invalidDataCount = this.invalidDataSections.length;
      console.log("this.invalidDataSections =============", this.invalidDataSections)
    }
  }

  apiCallStarted(startedFrom: string) {
    OutOfOfficeService.apiCallsInProgress++;
    this.pendingApiCalls.push(startedFrom);
    this.allCallsCompleted.next(false);
    console.log("pendingApiCalls ==> :",this.pendingApiCalls);
  }


  apiCallCompleted(endedFrom: string) {
    OutOfOfficeService.apiCallsInProgress--;
    const i = this.pendingApiCalls.findIndex((p)=> p == endedFrom);
    i > -1 && this.pendingApiCalls.splice(i, 1);
    // console.log("pendingApiCalls ==> :",this.pendingApiCalls);
    if (OutOfOfficeService.apiCallsInProgress === 0) {
      this.allCallsCompleted.next(true);
    }
  }

  //indiviual vacations popup
  getOutOfOfficeById(userId: string, year: number) {
    return this.http.get(`${BASE_URL}odata/outOfOfficeById?$count=true&userId=${userId}&year=${year}&$orderby=userId`);
  }
  // years api
  getYearsList() {
    return this.http.get(`${BASE_URL}odata/year?$count=true`);
  }
  // very last grid
  getVacationDayById(id: string, year: any = new Date(Date.now()).getFullYear()) {
    return this.http.get(`${BASE_URL}odata/VacationDayById?$count=true&userId=${id}&year=${year}&$orderby=userId`);
  }
  // very last grid
  getOutOfOfficeSpreadSheet(year: any = new Date(Date.now()).getFullYear()) {
    return this.http.get(`${BASE_URL}odata/${this.config.appName === 'sales' ? 'outOfOfficeSpreadSheet': 'outOfOfficeSpreadSheetForService'}?$count=true&year=${year}&$orderBy=userId`);
  }
  saveOutOfOfficeSpreadSheet(payload: {userId: string, year: number, notes: string, vacation: number, floating: number, sick: number, isDeleted: boolean}[]) {
    return this.http.post(`${BASE_URL}odata/saveOutOfOfficeSpreadSheet`, payload);
  }
  saveOutOfOfficeById(payload: {userId: string, year: number, notes: string, vacation: number, floating: number, sick: number, isDeleted: boolean}[]) {
    return this.http.post(`${BASE_URL}odata/saveOutOfOfficeById`, payload);
  }
}
